import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _regeneratorRuntime from "@babel/runtime/regenerator";
import React from 'react';
import Loadable from 'react-loadable';
import { DefaultExtensionProvider } from '@atlaskit/editor-common/extensions';
import UFOLoadHold from '@atlaskit/react-ufo/load-hold';
import { getExtensionManifest, SECTION_EXTENSION_TYPE } from '@atlassian/company-hub-common';
import { DEFAULT_BACKGROUND_COLOR, DEFAULT_CONTENT_WIDTH, SECTION_EXTENSION_KEY } from '../../index';
import { messages } from './messages';
var SectionExtension = Loadable({
  loader: function () {
    var _loader = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            _context.next = 2;
            return import( /* webpackChunkName: "@atlaskit-internal_SectionExtension" */'../section-extension');
          case 2:
            return _context.abrupt("return", _context.sent.SectionExtension);
          case 3:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }));
    function loader() {
      return _loader.apply(this, arguments);
    }
    return loader;
  }(),
  loading: function loading() {
    return /*#__PURE__*/React.createElement(UFOLoadHold, {
      name: "section-extension-loader"
    });
  }
});
var sectionParameters = function sectionParameters(intl) {
  return {
    extensionTitle: intl.formatMessage(messages.lozengeTitle),
    backgroundColor: DEFAULT_BACKGROUND_COLOR,
    contentWidth: DEFAULT_CONTENT_WIDTH
  };
};
export var sectionExtensionProvider = function sectionExtensionProvider(_ref) {
  var getSectionExtensionContents = _ref.getSectionExtensionContents,
    mode = _ref.mode,
    propsProvider = _ref.propsProvider;
  return /*#__PURE__*/function () {
    var _ref3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee5(_ref2) {
      var contentId, editorActions, openConfigPanel, intl, title, description, parameters, type, key, initialContentText, icons, update, render, additionalModuleNodeProps;
      return _regeneratorRuntime.wrap(function _callee5$(_context5) {
        while (1) switch (_context5.prev = _context5.next) {
          case 0:
            contentId = _ref2.contentId, editorActions = _ref2.editorActions, openConfigPanel = _ref2.openConfigPanel, intl = _ref2.intl;
            title = intl.formatMessage(messages.title);
            description = intl.formatMessage(messages.description);
            parameters = sectionParameters(intl);
            type = SECTION_EXTENSION_TYPE;
            key = SECTION_EXTENSION_KEY;
            initialContentText = {
              header: intl.formatMessage(messages.contentHeader),
              subHeader: intl.formatMessage(messages.contentSubHeader),
              placeholderTitle: intl.formatMessage(messages.placeHolderTitle)
            };
            icons = {
              '48': function _() {
                return import( /* webpackChunkName: "@atlaskit-internal_atlaskitIconCorePremium" */'@atlaskit/icon/core/premium').then(function (_ref4) {
                  var PremiumIcon = _ref4.default;
                  return function () {
                    return /*#__PURE__*/React.createElement(PremiumIcon, {
                      color: "var(--ds-icon-subtle, #626F86)",
                      label: "",
                      spacing: "spacious"
                    });
                  };
                });
              }
            };
            update = /*#__PURE__*/function () {
              var _ref5 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
                var _editorActions$getSel, _selectedNode$attrs;
                var selectedNode, selectedLocalId;
                return _regeneratorRuntime.wrap(function _callee2$(_context2) {
                  while (1) switch (_context2.prev = _context2.next) {
                    case 0:
                      selectedNode = editorActions === null || editorActions === void 0 || (_editorActions$getSel = editorActions.getSelectedNode()) === null || _editorActions$getSel === void 0 ? void 0 : _editorActions$getSel.toJSON();
                      selectedLocalId = selectedNode === null || selectedNode === void 0 || (_selectedNode$attrs = selectedNode.attrs) === null || _selectedNode$attrs === void 0 ? void 0 : _selectedNode$attrs.localId;
                      if (!!selectedLocalId && openConfigPanel) {
                        openConfigPanel(selectedLocalId);
                      }
                    case 3:
                    case "end":
                      return _context2.stop();
                  }
                }, _callee2);
              }));
              return function update() {
                return _ref5.apply(this, arguments);
              };
            }();
            render = /*#__PURE__*/function () {
              var _ref6 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3() {
                return _regeneratorRuntime.wrap(function _callee3$(_context3) {
                  while (1) switch (_context3.prev = _context3.next) {
                    case 0:
                      return _context3.abrupt("return", function (_ref7) {
                        var node = _ref7.node,
                          actions = _ref7.actions;
                        return /*#__PURE__*/React.createElement(SectionExtension, {
                          contentId: contentId,
                          extensionNode: node,
                          editorActions: editorActions,
                          mbeActions: actions,
                          mode: mode,
                          propsProvider: propsProvider
                        });
                      });
                    case 1:
                    case "end":
                      return _context3.stop();
                  }
                }, _callee3);
              }));
              return function render() {
                return _ref6.apply(this, arguments);
              };
            }();
            additionalModuleNodeProps = {
              __allowBodiedOverride: true
            };
            return _context5.abrupt("return", new DefaultExtensionProvider([getExtensionManifest({
              key: key,
              icons: icons,
              parameters: parameters,
              update: update,
              render: render,
              title: title,
              type: type,
              description: description,
              source: 'premiumSectionInsert',
              nodeType: 'multiBodiedExtension',
              quickInsertAction: function () {
                var _quickInsertAction = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4() {
                  return _regeneratorRuntime.wrap(function _callee4$(_context4) {
                    while (1) switch (_context4.prev = _context4.next) {
                      case 0:
                        return _context4.abrupt("return", Promise.resolve({
                          type: 'multiBodiedExtension',
                          key: 'hub-section',
                          attrs: {
                            extensionType: type,
                            extensionKey: 'hub-section',
                            layout: 'full-width',
                            parameters: parameters
                          },
                          content: getSectionExtensionContents(initialContentText)
                        }));
                      case 1:
                      case "end":
                        return _context4.stop();
                    }
                  }, _callee4);
                }));
                function quickInsertAction() {
                  return _quickInsertAction.apply(this, arguments);
                }
                return quickInsertAction;
              }(),
              additionalModuleNodeProps: additionalModuleNodeProps
            })]));
          case 12:
          case "end":
            return _context5.stop();
        }
      }, _callee5);
    }));
    return function (_x) {
      return _ref3.apply(this, arguments);
    };
  }();
};